import MainPage from "./components/Index";

const routes = {
  path: "dashboard",
  children: [{ path: "", element: <MainPage /> }],
};

export default routes;
